import * as React from 'react'
import { ReactElement } from 'react'
import { Route, Switch } from 'react-router'
import PartyOverview from '../v2/pages/Party/PartyOverview'
import AddLegalPerson from '../v2/pages/Party/mutate/AddLegalPersonPage'
import EditLegalPerson from '../v2/pages/Party/mutate/EditLegalPersonPage'
import AddNaturalPerson from '../v2/pages/Party/mutate/AddNaturalPersonPage'
import EditNaturalPerson from '../v2/pages/Party/mutate/EditNaturalPersonPage'
import FilePartyOverview, { FilePartyOverviewProps } from './Party/FilePartyOverview'

type Props = {
    global?: boolean
    prefix?: string
    overviewProps?: FilePartyOverviewProps
}

export default function Parties(props: Props): ReactElement {
    const prefix: string = props.prefix || ''

    return (
        <Switch>
            <Route exact path="/party" component={PartyOverview} />
            <Route path={`${prefix}/party/natural/add`} component={AddNaturalPerson} />
            <Route path={`${prefix}/party/natural/:id/edit`} component={EditNaturalPerson} />
            <Route path={`${prefix}/party/legal/add`} component={AddLegalPerson} />
            <Route path={`${prefix}/party/legal/:id/edit`} component={EditLegalPerson} />
            <Route path="/file/:fileId/party" render={() => <FilePartyOverview {...props.overviewProps} />} />
        </Switch>
    )
}
